import { Grid2, Typography } from "@mui/material";
import React from "react";
import PresentationChartLineIco from "../../../../assets/icons/PresentationChartLineIco";
import CommonButton from "../../../../component/Button";
import { StyledFlexRowView } from "../../../common-components/StyledComponents";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent";
import CommonTable from "./CommonTable";

function SowDocuments({
  isEdit,
  handleClickVerify,
  seeClicked,
  documentSelectedRows,
  documentTableData,
  handleDocumentFileChange,
  handleDocumentUploadClick,
  documentStatusOptions,
  handleDocumentStatusChange,
  handleDocumentTableBodyData,
  handleDocumentRowCheckboxChange,
  fileInputRef,
}) {
  // const [documentSelectedRows, setDocumentSelectedRows] = useState([]);
  // const [documentTableData, setDocumentTableData] = useState([
  //   {
  //     id: "100",
  //     fileName: "Project Atlantis.pdf",
  //     owner: "Olivia Rhye",
  //     status: "Approval Pending",
  //     note: "",
  //   },
  //   {
  //     id: "101",
  //     fileName: "Icanio References",
  //     owner: "Olivia Rhye",
  //     status: "Approval Pending",
  //     note: "",
  //   },
  //   {
  //     id: "102",
  //     fileName: "Pitch Deck.ppt",
  //     owner: "Olivia Rhye",
  //     status: "Approval Pending",
  //     note: "",
  //   },
  // ]);

  // const fileInputRef = useRef(null);

  // const handleDocumentFileChange = (event) => {
  //   const file = event.target.files[0]; // Get the selected file
  //   if (file) {
  //     const newFileEntry = {
  //       id: Date.now().toString(), // Generate a unique ID
  //       fileName: file.name,
  //       owner: "Olivia Rhye", // Set the owner dynamically if needed
  //       status: "Approval Pending",
  //       note: "",
  //     };

  //     setDocumentTableData((prevData) => [...prevData, newFileEntry]);
  //   }
  // };

  // const handleDocumentUploadClick = () => {
  //   fileInputRef.current.click(); // Trigger file input when button is clicked
  // };

  const mileStonesHeaderData = ["Document", "Owner", "Status", "Notes", ""];
  // const documentStatusOptions = [
  //   { label: "Approval Pending", color: "#DC6803" },
  //   { label: "Enterprise Approved", color: "#9E77ED" },
  //   { label: "Ready for Final Review", color: "#17B26A" },
  //   // { label: "NA", color: "#A0A0A0" },
  // ];

  // const handleDocumentStatusChange = (event, rowId) => {
  //   const newStatus = event.target.value;
  //   setDocumentTableData((prevData) =>
  //     prevData.map((row) =>
  //       row.id === rowId ? { ...row, status: newStatus } : row
  //     )
  //   );
  // };

  // const handleDocumentTableBodyData = (row) => {
  //   return (
  //     <>
  //       <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
  //         {row.fileName}
  //       </TableCell>
  //       <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
  //         {row.owner}
  //       </TableCell>
  //       <TableCell>
  //         <FormControl>
  //           <Select
  //             value={row.status || ""}
  //             displayEmpty
  //             onChange={(event) => handleDocumentStatusChange(event, row.id)} // Handle change
  //             renderValue={(selected) => {
  //               const selectedOption = documentStatusOptions.find(
  //                 (option) => option.label === selected
  //               );

  //               if (!selectedOption) {
  //                 return (
  //                   <Typography sx={{ color: "#A0A0A0" }}>
  //                     Select Level
  //                   </Typography>
  //                 );
  //               }

  //               return (
  //                 <Box sx={{ display: "flex", alignItems: "center" }}>
  //                   <Box
  //                     sx={{
  //                       width: 8,
  //                       height: 8,
  //                       borderRadius: "50%",
  //                       backgroundColor: selectedOption.color,
  //                       marginRight: "8px",
  //                     }}
  //                   />
  //                   <Typography>{selectedOption.label}</Typography>
  //                 </Box>
  //               );
  //             }}
  //             IconComponent={ExpandMore}
  //             sx={{
  //               "& .MuiSelect-select": {
  //                 paddingLeft: "10px !important",
  //                 paddingTop: "1px !important",
  //                 paddingBottom: "1px !important",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 borderRadius: "6px",
  //                 paddingRight: "25px !important",
  //               },
  //               "& .MuiOutlinedInput-notchedOutline": {
  //                 borderColor: "#D0D5DD",
  //                 boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
  //               },
  //               "& .MuiSelect-icon": {
  //                 fontSize: "14px",
  //               },
  //             }}
  //           >
  //             {documentStatusOptions.map((option) => (
  //               <MenuItem key={option.label} value={option.label}>
  //                 <Box sx={{ display: "flex", alignItems: "center" }}>
  //                   <Box
  //                     sx={{
  //                       width: 8,
  //                       height: 8,
  //                       borderRadius: "50%",
  //                       backgroundColor: option.color,
  //                       marginRight: "8px",
  //                     }}
  //                   />
  //                   {option.label}
  //                 </Box>
  //               </MenuItem>
  //             ))}
  //           </Select>
  //         </FormControl>
  //       </TableCell>
  //       <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
  //         {row.note ? row.note : "-"}
  //       </TableCell>
  //       <TableCell>
  //         <DotsVerticalIco />
  //       </TableCell>
  //     </>
  //   );
  // };

  // const handleDocumentRowCheckboxChange = (rowId) => {
  //   setDocumentSelectedRows((prevSelectedRows) =>
  //     prevSelectedRows.includes(rowId)
  //       ? prevSelectedRows.filter((id) => id !== rowId)
  //       : [...prevSelectedRows, rowId]
  //   );
  // };

  return (
    <Grid2 container spacing={4}>
      <Grid2 size={12}>
        <StyledSpaceBetweenBox>
          <StyledFlexRowView style={{ gap: "30px" }}>
            <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
              {"Documents"}
            </Typography>
            <CommonButton
              variant="contained"
              color="white"
              background="#7F56D9"
              fontWeight="700"
              value="Mark as verified"
              padding="8px 15px"
              onClick={handleClickVerify}
            />
          </StyledFlexRowView>

          <StyledFlexRowView>
            <CommonButton
              variant="outlined"
              color="#344054"
              border="#D0D5DD"
              fontWeight="600"
              value="Generate Pitch Deck"
              padding={"8px 15px"}
              startIcon={<PresentationChartLineIco />}
            />
            <CommonButton
              variant="contained"
              color="white"
              background="#7F56D9"
              fontWeight="700"
              value="Upload Files"
              padding="8px 15px"
              onClick={handleDocumentUploadClick}
            />
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleDocumentFileChange}
            />
          </StyledFlexRowView>
        </StyledSpaceBetweenBox>
      </Grid2>

      <Grid2 size={12}>
        <CommonTable
          data={documentTableData}
          columns={mileStonesHeaderData}
          onSortChange={(col) => console.log("Sort by", col)}
          handleTableBodyData={handleDocumentTableBodyData}
          withCheckbox={true}
          marginTop={"0px"}
          onRowCheckboxChange={handleDocumentRowCheckboxChange}
        />
      </Grid2>
    </Grid2>
  );
}

export default SowDocuments;
